<template>
  <div
    class="px-3"
    >
    <div
      class="pb-2 d-flex"
      style="gap: 12px"
      :key="band"
      >
      <v-text-field
        append-icon="mdi-magnify"
        solo
        outlined
        flat
        label="Buscar..."
        dense
        persistent-hint
        hint="Por concepto, caja, sub-cuenta, dirección o nombre de cliente."
        class="rounded-lg"
        style="max-width: 355px"
        v-model="search"
        ></v-text-field>

      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            label="Rango de fechas"
            append-icon="mdi-calendar"
            solo
            outlined
            flat
            clearable
            dense
            class="rounded-lg"
            style="max-width: 225px"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="saveDate"
            >
            Confirmar
          </v-btn>
        </v-date-picker>
      </v-dialog>

      <v-spacer></v-spacer>

      <create
        @reload="fetchPayments"
        ></create>
    </div>
    <list-header></list-header>
    <template
      v-for="payment in payments"
      >
      <payment-card
        :key="payment.id"
        :payment="payment"
        ></payment-card>
      <v-divider></v-divider>
    </template>

    <div
      style="max-width: 600px"
      class="mx-auto mt-3"
      >
      <v-pagination
        v-if="pages > 1"
        :length="pages"
        v-model="page"
        ></v-pagination>
    </div>
  </div>
</template>

<script>
import { Payments } from '@/graphql/queries/payment'

const ListHeader = () => import('./Header')
const PaymentCard = () => import('./Card')
const Create = () => import('./Create')

export default {
  data: () => ({
    payments: [],
    search: null,
    page: 1,
    per: 13,
    pages: 1,
    band: 0,
    date: null,
    timeout: null,
    modal: false,
  }),

  watch: {
    page () {
      this.fetchPayments ()
    },

    search () {
      if (this.timeout)
        clearTimeout(this.timeout)

      this.timeout = setTimeout( () => {
        this.page = 1
        this.fetchPayments()
      }, 400)
    },

    date (val) {
      if (!val) {
        this.$refs.dialog.save(this.date)

        this.page = 1

        this.fetchPayments()
      }
    }
  },

  created () {
    this.fetchPayments ()
  },

  methods: {
    fetchPayments () {
      this.$apollo.query({
        query: Payments,
        variables: {
          page: this.page,
          perPage: this.per,
          search: this.search,
          date: this.date
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.payments = res.data.payments.payments
        this.pages = res.data.payments.pages
        this.band += 1
      })
    },
    
    saveDate () {
      this.$refs.dialog.save(this.date)

      this.page = 1

      this.fetchPayments()
    }
  },

  components: {
    ListHeader,
    PaymentCard,
    Create
  }
}
</script>
